<div>
  <div
    bsModal
    #flagGroupTemplateModal="bs-modal"
    class="modal modal-overlay"
    tabindex="-1"
    role="dialog"
    [config]="{ backdrop: false }"
    aria-labelledby="templateModal">
    <div class="modal-dialog" style="max-width: 58%; top: 5%" role="document">
      <ngx-loading [show]="loading"></ngx-loading>
      <div class="modal-content">
        <div class="modal-header">
          <h3 id="templateModal" class="modal-title">Select Template</h3>
        </div>
        <div class="modal-header" style="justify-content: unset">
          <h4 style="margin: 3px 15px 0 0">Filter</h4>
          <div class="input-group" style="width: 19rem">
            <input
              type="text"
              style="border-radius: 6px; font-size: 15px"
              placeholder="Group/sub-group/template name"
              class="form-control"
              [(ngModel)]="searchQuery"
              (ngModelChange)="applyFilter()" />
            <div
              class="input-group-append"
              style="cursor: pointer; position: absolute; right: 15px; top: 6px; z-index: 9"
              *ngIf="searchQuery"
              (click)="clearSearch()">
              <span style="color: #aaa; font-size: 1.2em"><i class="fa fa-close"></i></span>
            </div>
            <div
              class="input-group-append"
              style="position: absolute; right: 15px; top: 6px; z-index: 9"
              *ngIf="!searchQuery">
              <span style="color: #2f3032; font-size: 1.2em"><i class="fa fa-search"></i></span>
            </div>
          </div>
        </div>
        <div class="modal-body temp-body">
          <!-- sidebar -->
          <div class="temp-sidebar">
            <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
              <!-- Leaf Node (Template) -->
              <mat-tree-node
                *matTreeNodeDef="let node"
                matTreeNodePadding
                [matTreeNodePaddingIndent]="8"
                [ngClass]="{ 'mat-tree-node-template': node.type === 'FlagTemplate' }">
                <button mat-icon-button disabled></button>
                <a
                  (click)="previewTemplate(node.node)"
                  *ngIf="node.type == 'FlagTemplate'"
                  style="cursor: pointer; display: block; padding: 2px"
                  [ngClass]="{ 'selected-template': node.id === selectedTemplateId }">
                  <span [innerHTML]="'<b>-</b> ' + (node.label || node.name)"></span>
                </a>
                <span *ngIf="node.type !== 'FlagTemplate'" class="disabled-node" [innerHTML]="node.name"></span>
              </mat-tree-node>

              <!-- Expandable Node (Group, SubGroup) -->
              <mat-tree-node
                *matTreeNodeDef="let node; when: hasChild"
                matTreeNodePadding
                matTreeNodeToggle
                [matTreeNodePaddingIndent]="10">
                <button mat-icon-button matTreeNodeToggle (click)="onNodeToggle()">
                  <mat-icon>
                    {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
                  </mat-icon>
                </button>
                <span
                  [innerHTML]="node.label || node.name"
                  (click)="onNodeToggle()"
                  [ngStyle]="{
                    'font-weight': node.name === group?.name || highlightNodes.includes(node) ? 'bold' : 'normal'
                  }">
                </span>
              </mat-tree-node>
            </mat-tree>
          </div>
          <!-- Main body -->
          <div class="temp-main">
            <h4>Preview</h4>
            <div *ngIf="!preview" class="center-main">
              <p><i>Please select a template to preview</i></p>
            </div>
            <div *ngIf="preview">
              <div class="grid-container">
                <div class="grid-item">
                  <strong>Flag type</strong>
                </div>
                <div class="grid-item">{{ showTemplate.subtype.type.name }}</div>

                <div class="grid-item">
                  <strong>Flag sub-type</strong>
                </div>
                <div class="grid-item">{{ getViolationValue(showTemplate.subtype.name) }}</div>

                <div class="grid-item">
                  <strong>Issue description</strong>
                </div>
                <div class="grid-item">{{ showTemplate.description }}</div>

                <div class="grid-item">
                  <strong>Elevated risk</strong>
                </div>
                <div class="grid-item">{{ showTemplate.violation.elevatedRisk | stripHtml }}</div>

                <div class="grid-item">
                  <strong>Why does this matter</strong>
                </div>
                <div class="grid-item">{{ showTemplate.violation.whyDoesThisMatter | stripHtml }}</div>

                <div class="grid-item">
                  <strong>Actions requested</strong>
                </div>
                <div class="grid-item">{{ showTemplate.violation.actionRequested | stripHtml }}</div>

                <div class="grid-item">
                  <strong>Documentation requested</strong>
                </div>
                <div class="grid-item">{{ showTemplate.violation.documentationRequested | stripHtml }}</div>

                <div class="grid-item">
                  <strong>Pictures</strong>
                </div>
                <div class="grid-item">Pictures ({{ showTemplate.helpPictures?.length || 0 }})</div>

                <div class="grid-item">
                  <strong>URL Title</strong>
                </div>
                <div class="grid-item">{{ showTemplate.violation.urlTitle }}</div>

                <div class="grid-item">
                  <strong>URL</strong>
                </div>
                <div class="grid-item">{{ showTemplate.violation.url }}</div>
              </div>
            </div>
          </div>
          <br />
        </div>
        <div class="modal-footer">
          <button type="button" class="btn aru btn-secondary" (click)="cancel()">Close</button>
          <button
            *ngIf="!createGroup"
            type="button"
            class="btn aru btn-primary ml-2"
            [disabled]="!preview"
            (click)="apply()">
            Apply Template
          </button>

          <button
            *ngIf="createGroup"
            type="button"
            class="btn aru btn-primary ml-2"
            [disabled]="!preview"
            (click)="createGroupWithTemplate()">
            Create Group
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Confirmation Popup -->

<div>
  <div
    bsModal
    #confirmationModal="bs-modal"
    class="modal modal-con-overlay"
    tabindex="-1"
    role="dialog"
    [config]="{ backdrop: false }"
    aria-labelledby="confirmation">
    <div class="modal-dialog modal-md" style="top: 20%" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h3 id="confirmation" class="modal-title">Confirmation</h3>
        </div>
        <div class="modal-body">
          <p>
            The selected template fields differ from the current ones. <br />
            Are you sure you want to apply this template?
          </p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn aru btn-secondary" (click)="cancelConfirmation()">Close</button>
          <button type="button" class="btn aru btn-primary ml-2" (click)="applyConfirmation()">Apply</button>
        </div>
      </div>
    </div>
  </div>
</div>
